/** @jsxImportSource @emotion/react */
import "twin.macro";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { Route, Switch } from "react-router-dom";
import { ROUTES } from "./settings/routes";
import {
	AccountSetup,
	ErrorPage,
	ForgotPassword,
	Home,
	Invitation,
	MakeNotes,
	MyPlan,
	MySettings,
	NewPassword,
	Notifications,
	OurPhotos,
	OurStory,
	Registry,
	ResetPassword,
	ResetPin,
	SearchPage,
	Shop,
	Signin,
	Signup,
	Timeline,
	Vendor,
	Vendors,
	VerifyAccount,
	Wallet,
} from "./pages";
import PrivateRoute from "./settings/PrivateRoute";
import Auth from "./lib/middleware/auth";
import axios from "axios";
import { TimelinePostDetail } from "./components";
import BecomeAVendor from "./pages/Vendors/BecomeAVendor";

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			retry: false,
			staleTime: 30000,
		},
	},
});

function App() {
	const isAuth = Auth.isAuthenticated();
	const axiosApiInstance = axios.create();
	const token = Auth.getToken();

	// // Request interceptor for API calls
	axiosApiInstance.interceptors.request.use(
		async (config) => {
			config.headers.Authorization = `Bearer ${token}`;
			config.timeout = 120000;
			return config;
		},
		(error) => {
			Promise.reject(error);
			console.info(`[axiosApiInstance request:: `, error);
		}
	);
	(function () {
		if (token) {
			axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
		} else {
			delete axios.defaults.headers.common["Authorization"];
		}
	})();

	return (
		<QueryClientProvider client={queryClient}>
			<Switch>
				{isAuth ? (
					<PrivateRoute exact path={ROUTES.INDEX} component={Home} />
				) : (
					<Route exact path={ROUTES.INDEX} component={Signin} />
				)}

				<PrivateRoute exact path={ROUTES.DASHBOARD} component={Home} />
				<Route exact path={ROUTES.LOGIN} component={Signin} />
				<Route exact path={ROUTES.SIGINUP} component={Signup} />
				<Route
					exact
					path={ROUTES.FORGOTPASSWORD}
					component={ForgotPassword}
				/>
				<Route
					exact
					path={ROUTES.NEWPASSWORD}
					component={NewPassword}
				/>
				<Route exact path={ROUTES.RESETPIN} component={ResetPin} />
				<Route
					exact
					path={ROUTES.RESETPASSWORD}
					component={ResetPassword}
				/>
				<Route
					exact
					path={ROUTES.VERIFICATION}
					component={VerifyAccount}
				/>
				<Route exact path={ROUTES.TIMELINE} component={Timeline} />

				<Route
					exact
					path={ROUTES.TIMELINEPOSTDETAIL}
					component={TimelinePostDetail}
				/>
				{/* Authenticated Pages */}
				<PrivateRoute
					exact
					path={ROUTES.ACCOUNTSETUP}
					component={AccountSetup}
				/>
				<PrivateRoute
					exact
					path={ROUTES.NOTIFICATIONS}
					component={Notifications}
				/>
				<PrivateRoute
					exact
					path={ROUTES.SEARCH}
					component={SearchPage}
				/>
				<PrivateRoute exact path={ROUTES.WALLET} component={Wallet} />

				<PrivateRoute
					exact
					path={ROUTES.SETTINGS}
					component={MySettings}
				/>
				<PrivateRoute
					exact
					path={ROUTES.OURSTORY}
					component={OurStory}
				/>
				<PrivateRoute
					exact
					path={ROUTES.OURPHOTOS}
					component={OurPhotos}
				/>
				<PrivateRoute
					exact
					path={ROUTES.MAKENOTES}
					component={MakeNotes}
				/>
				<PrivateRoute
					exact
					path={ROUTES.MAKEPLANS}
					component={MyPlan}
				/>
				<PrivateRoute
					exact
					path={ROUTES.INVITEFRIEND}
					component={Invitation}
				/>
				<PrivateRoute
					path={[`${ROUTES.REGISTRY}/:path`, `${ROUTES.REGISTRY}`]}
					component={Registry}
				/>
				<PrivateRoute exact path={ROUTES.SHOP} component={Shop} />
				<PrivateRoute exact path={ROUTES.VENDORS} component={Vendors} />
				<PrivateRoute
					exact
					path={ROUTES.BECOMEAVENDOR}
					component={BecomeAVendor}
				/>
				<PrivateRoute
					exact
					path={ROUTES.VIEWVENDOR}
					component={Vendor}
				/>
				{/* Error Page */}
				<Route path={ROUTES.ERRORPAGE} component={ErrorPage} />
			</Switch>
			<ReactQueryDevtools initialIsOpen={false} />
		</QueryClientProvider>
	);
}

export default App;
